import { executeAPI } from "repositories/db-repository"

export const insertPurchaseTransaction = (data, user_name, onSuccess, onError) => {
    executeAPI(`${process.env.REACT_APP_REMAX_PS_API_URL}`, "insert_purchase_transaction", 
    {
        outlet_group_id: data?.outlet_group_id,
        outlet_group_name: data?.outlet_group_name,
        outlet_group_phone_number: data?.outlet_group_phone_number,
        outlet_group_email_address: data?.outlet_group_email_address,
        public_id: data?.public_id,
        user_id: data?.user_id,
        user_name: data?.user_name,
        outlet_id: data?.outlet_id,
        outlet_name: data?.outlet_name,
        outlet_phone_number: data?.outlet_phone_number,
        outlet_email_address: data?.outlet_email_address,
        latest_flow_detail_id: data?.latest_flow_detail_id,
        purchase_header_id: data?.purchase_header_id,
        warehouse_id: data?.warehouse_id,
        warehouse_name: data?.warehouse_name,
        warehouse_address: data?.warehouse_address,
        supplier_id: data?.supplier_id,
        supplier_name: data?.supplier_name,
        supplier_phone_number: data?.supplier_phone_number,
        supplier_email_address: data?.supplier_email_address,
        supplier_address: data?.supplier_address,
        notes: data?.notes,
        flow_detail_id: data?.flow_detail_id,
        currency_id: data?.currency_id,
        rate: data?.rate,
        created_by: user_name
    },
    onSuccess, onError) 
}

export const updatePurchaseTransaction = (data, user_name, onSuccess, onError) => {
    executeAPI(`${process.env.REACT_APP_REMAX_PS_API_URL}`, "update_purchase_transaction", 
    {
        id: data?.id,
        origin: data?.origin,
        outlet_group_id: data?.outlet_group_id,
        outlet_group_name: data?.outlet_group_name,
        outlet_group_phone_number: data?.outlet_group_phone_number,
        outlet_group_email_address: data?.outlet_group_email_address,
        public_id: data?.public_id,
        user_id: data?.user_id,
        user_name: data?.user_name,
        outlet_id: data?.outlet_id,
        outlet_name: data?.outlet_name,
        outlet_phone_number: data?.outlet_phone_number,
        outlet_email_address: data?.outlet_email_address,
        latest_flow_detail_id: data?.latest_flow_detail_id,
        purchase_header_id: data?.purchase_header_id,
        warehouse_id: data?.warehouse_id,
        warehouse_name: data?.warehouse_name,
        warehouse_address: data?.warehouse_address,
        supplier_id: data?.supplier_id,
        supplier_name: data?.supplier_name,
        supplier_phone_number: data?.supplier_phone_number,
        supplier_email_address: data?.supplier_email_address,
        supplier_address: data?.supplier_address,
        notes: data?.notes,
        flow_detail_id: data?.flow_detail_id,
        currency_id: data?.currency_id,
        rate: data?.rate,
        record_status: "U",
        updated_by: user_name
    },
    onSuccess, onError)
}

